<template>
    <div class="pt-1">
        <b-modal id="upload-registry-file-ext" title="Dosya Yükle" no-close-on-esc no-close-on-backdrop>
            <employee-registry-file-document-upload v-model="file"></employee-registry-file-document-upload>
            <template #modal-footer><v-executer :loading="loading" text="Yükle" :action="uploadFile"></v-executer></template>
        </b-modal>

        <v-file-viewer ref="fileViewer"></v-file-viewer>

        <h4 class="px-1">Harici Sicil Dosyaları</h4>
        <v-table    ref="extTable"
                    :add-callback="uploadFileShow"
                    with-items
                    :items="files"
                    name="employee-registry-file-ext"
                    :fields="fields"
                    :buttons="buttons"
                    :settings="false">
        </v-table>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import EmployeeRegistryFileDocumentUpload from './EmployeeRegistryFileDocumentUpload.vue'
import VFileViewer from '@/components/VFileViewer.vue'
import Additional from '@/utilities/additional'

export default{
    props:{
        id:[String,Number],
        code:[String,null]
    },
    components:{
        EmployeeRegistryFileDocumentUpload,
        VFileViewer,
    },
    data(){
        return {
            files:[],
            fields:[
                {key:'FileName',name:'Belge',thClass:'w-100'}
            ],
            buttons:[
                { text:"Görüntüle",key:"view",icon:"EyeIcon", variant:"success", action:this.view,condition:(item) => item.File != null },
                { text:"İndir",key:"download",icon:"DownloadIcon", variant:"warning", action:this.download,condition:(item) => item.File != null },
            ],
            file:{
                SystemCode:'EMPLOYEE_REGISTRY_DOCUMENT_FILLED_EXTERNAL',
                RegistryDocumentId:null,
                EmployeeId:this.id,
                File:null,
                External:true
            },
        }
    },
    mounted(){
        if(this.id && this.code){
            this.getRegistryDocuments()
        }
    },
    watch:{
        id(oldVal,newVal){
            if(oldVal != newVal) this.getRegistryDocuments()
        },
        code(oldVal,newVal){
            if(oldVal != newVal) this.getRegistryDocuments()
        }
    },
    methods:{
        uploadFileShow(){
            this.$showModal('upload-registry-file-ext')
        },
        getRegistryDocuments(){
            this.$refs.extTable.setLoading(true)
            EmployeeOperationsApi.Employee.RegistryFile.ExternalList(this.code,this.id).then(res=>{
                this.files = res.data
                this.$refs.extTable.setLoading(false)
            })
        },
        view(item){
            this.$refs.fileViewer.view(item.File.FilePath)
        },
        download(item){
            this.$refs.extTable.rowLoading(true)
            Additional.GetBlobFile(item.File.FilePath).then(blob=>{
                Additional.DownloadFile(blob.data,item.File.FileName)
                this.$refs.extTable.rowLoading(false)
            }).catch(err=>{
                this.$refs.extTable.rowLoading(false)
            })
        },
        async uploadFile(){
            this.loading = true
            this.file.EmployeeId = this.id
            let formData = await Additional.ToFormData(this.file,['File'])
            EmployeeOperationsApi.Employee.RegistryFile.Upload(formData).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.getRegistryDocuments()
                    this.$hideModal('upload-registry-file-ext')
                }
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
    }
}
</script>